import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { BreadcrumbBuilder } from '../../../../../shared/ui/breadcrumb/breadcrumb-builder';
import { EventBus } from '../../../../../shared/event/bus';
import { AbstractListComponent } from '../../../../../shared/crud/component/list.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'admin-license-list',
  templateUrl: './list.component.html',
  styleUrls: [ './list.component.scss' ]
})
export class AdminLicenseListComponent extends AbstractListComponent implements OnInit, OnDestroy {

  selectedRowId: number = 0;

  constructor(httpClient: HttpClient,
              toastrService: ToastrService,
              router: Router,
              route: ActivatedRoute,
              eventBus: EventBus,
              changeDetector: ChangeDetectorRef,
              private breadcrumbBuilder: BreadcrumbBuilder) {
    super(httpClient, toastrService, router, route,);
  }

  getResourceUrl(): string {
    return '/admin/license';
  }

  ngOnInit() {
    this.breadcrumbBuilder.clear();
    this.breadcrumbBuilder.add({
      label: 'Admin / Licenses',
      url: '/licenses'
    });

    super.ngOnInit();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  load(): Subscription {
    this.loading = true;
    this.loadingPromise = this.fetchRemoteSource().subscribe();
    this.loadingPromise.add(() => {
      this.loading = false;
    });

    return this.loadingPromise;
  }

  onAdd() {
    const newRow = {
      id: undefined,
      name: 'License #' + (this.pagination.rows.length + 1),
      features: [],
      licensePricing: [],
      orderNumber: this.pagination.rows.length + 1
    };

    this.httpClient.post(`/admin/license`, {
      name: newRow.name,
      features: [],
      orderNumber: newRow.orderNumber
    })
      .subscribe((response: any) => {
        response.licensePricing = response.licensePricing || [];
        this.pagination.rows.push(response);
      }, () => {
        this.toastrService.error('Failed to add new license');
      });
  }


  onDelete(rowId) {
    if (!rowId) {
      this.load();
    } else {
      this.delete(rowId);
    }
  }
}
